// spaceEffects.js
import React, { useEffect } from 'react';

const SpaceEffects = () => {
  useEffect(() => {
    // Create stars and planets in the background
    const createStars = () => {
      const appContainer = document.querySelector('.coin-flip-app');
      if (!appContainer) return;
      
      // Remove any existing stars first
      const existingStars = document.querySelectorAll('.space-star, .space-planet');
      existingStars.forEach(star => star.remove());
      
      // Create stars
      for (let i = 0; i < 70; i++) {
        const star = document.createElement('div');
        star.className = 'space-star';
        
        // Random size, position and animation delay
        const size = Math.random() * 3 + 1;
        const posX = Math.random() * 100;
        const posY = Math.random() * 100;
        const animationDelay = Math.random() * 5;
        const animationDuration = 3 + Math.random() * 7;
        const opacity = 0.3 + Math.random() * 0.7;
        
        // Set styles
        star.style.width = `${size}px`;
        star.style.height = `${size}px`;
        star.style.left = `${posX}vw`;
        star.style.top = `${posY}vh`;
        star.style.setProperty('--delay', `${animationDelay}s`);
        star.style.setProperty('--duration', `${animationDuration}s`);
        star.style.setProperty('--opacity', opacity);
        
        // Append to container
        appContainer.appendChild(star);
      }
      
      // Create a few planets
      const gradients = [
        'linear-gradient(135deg, #4f46e5, #6366f1)',
        'linear-gradient(135deg, #10b981, #059669)',
        'linear-gradient(135deg, #f59e0b, #d97706)',
        'linear-gradient(135deg, #6366f1, #4338ca)'
      ];
      
      for (let i = 0; i < 4; i++) {
        const planet = document.createElement('div');
        planet.className = 'space-planet';
        
        // Random size, position and animation
        const size = Math.random() * 30 + 10;  // 10-40px
        const posX = Math.random() * 90 + 5;  // Keep away from edges
        const posY = Math.random() * 90 + 5;
        const animationDelay = Math.random() * 8;
        const blur = 5 + Math.random() * 15;
        
        // Set styles
        planet.style.width = `${size}px`;
        planet.style.height = `${size}px`;
        planet.style.left = `${posX}vw`;
        planet.style.top = `${posY}vh`;
        planet.style.background = gradients[i % gradients.length];
        planet.style.boxShadow = `0 0 ${blur}px rgba(79, 70, 229, 0.3)`;
        planet.style.animationDelay = `${animationDelay}s`;
        planet.style.filter = 'blur(4px)';
        
        // Append to container
        appContainer.appendChild(planet);
      }
    };
    
    // Initialize stars
    createStars();
    
    // Recreate stars on window resize
    window.addEventListener('resize', createStars);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', createStars);
      
      const stars = document.querySelectorAll('.space-star, .space-planet');
      stars.forEach(star => star.remove());
    };
  }, []);
  
  // This component doesn't render anything directly
  return null;
};

export default SpaceEffects;